import type { ExternalTableSchema } from '@packages/table-builder';

export const featureSetTable: ExternalTableSchema = {
  metadata: {
    title: 'Feature Set',
    entity: 'FeatureSet',
    description: 'Current list of Wealthlane system Feature Set.',
  },

  dataSource: {
    endpoint: '/api/identity/feature-set',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      SelectedPermissions: 'filters.SelectedPermissions',
    },
  },

  columns: [
    {
      field: 'name',
      header: 'Name',
      type: 'text',
      width: 200,
      align: 'left',
      sortable: true,
    },
    {
      field: 'description',
      header: 'Description',
      type: 'text',
      width: 200,
      align: 'left',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_FEATURE_SET', label: 'View' },
      {
        id: 'EDIT_FEATURE_SET',
        label: 'Edit',
      },
      {
        id: 'DELETE_FEATURE_SET',
        label: 'Delete',
        variant: 'danger',
      },
    ],
    toolbar: {
      primary: {
        id: 'ADD_FEATURE_SET',
        label: 'Add Feature Set',
        icon: 'add_circle_outline',
      },
      secondary: [
        {
          id: 'BULK_EDIT_FEATURE_SET',
          label: 'Bulk Edit',
          icon: 'discover_tune',
          requiresSelection: true,
        },
      ],
    },
  },

  features: {
    search: { enabled: true },
    customFilterToolbar: { openActionId: 'FILTER_FEATURE_SET' },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'id' },
    columnPreferences: {
      persistenceKey: 'Feature Set',
      resizable: true,
      reorderable: true,
    },
  },
};
